import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// cache-buster for the locale files; VERSION isn't defined outside Vite (tests)
const cacheBuster = typeof VERSION !== 'undefined' ? VERSION : '';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?h=' + cacheBuster,
    },
  });

export default i18n;
